module.exports = __webpack_public_path__ + "img/piramis-home.14197c96.png";